/* eslint-disable */
import React from "react";
import { Card } from "react-bootstrap";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import "./graph_overlay.css";
import HistoryList from "../includes/HistoryList";
import Engine from "../Engine";
import { Game } from "../../../../Helper";

class Canvas extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.canvasRef = React.createRef();
    this.isStopGame = React.createRef();
    this.isStopGame.current = true;
    this.gameISStarted = React.createRef();
    this.gameISStarted.current = false;
    this.engine = Engine;
    this.FPS = 30;
    this.startTime = null;
    this.serverElapsed = 0;
    this.lastMult = 1.00; // Track last bust multiplier for continuation
    this.speedPxPerSecond = 60; // Kept for potential future use
    this.chartMargin = 0;
    this.maxChartY = 0;
    this.baseY = 790;
    this.points = []; // Will hold bust points {x, y, mult}
    this.history = [];
    this.expectedRoundTime = 2250; // Default, will be calculated from history
    this.startRoundX = this.chartMargin;
    this.currentRoundIndex = 0;
    this.maxPoints = 400; // Limit to last 400 points to keep more history
    this.basePoints = 200; // Base points for zoom calculations (Increased to show ~20 labels of 15s)
    this.zoomLevel = 1.0; // Zoom level: 0.1 = zoomed in (30 pts), 1.0 = normal (300 pts)
    this.minZoom = 0.1;   // Min zoom (30 points)
    this.maxZoom = 1.0;   // Max zoom (300 points)
    this.isAnimating = false; // Flag to control animation loop
    this.averageBust = 1.00; // Initialize to avoid NaN
    this.yScaleMax = 50; // Dynamic max for Y scaling
    this.lastCrashPoint = null; // Store last crash point for persistent display

    // Animation state for smooth line drawing
    this.animatedX = 0; // Current animated X position for progressive drawing
    this.lastLiveX = 0; // Last known live point X position
    this.animationSpeed = 0.15; // How fast the line draws (0-1, higher = faster)
    this.lastTouchDistance = null; // Store distance between fingers for pinch zoom

    this.state = {
      imagesLoaded: true,
      loadingError: null,
      engine: Engine,
      connecting: true,
      hash: null,
      status: "",
      timer: "",
      rate: "",
      inPlay: true,
      current_amount: "1.00",
      lerp_amount: 1.00, // For smoothing "slowness" effect
      startedTime: 0,
      timePassed: 0,
      mousePos: null,
      hoveredPoint: null,
    };

    this.popups = []; // Array to hold floating profit popups {x, y, text, alpha}

    this.animationRef = {
      gameLoop: null,
    };

    this.drawChart = this.drawChart.bind(this);
    this.gameLoop = this.gameLoop.bind(this);
    this.clearAnimationData = this.clearAnimationData.bind(this);
    this.finish = this.finish.bind(this);
    this.waiting = this.waiting.bind(this);
    this.started = this.started.bind(this);
    this.busted = this.busted.bind(this);
    this.status = this.status.bind(this);
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.findNearestPoint = this.findNearestPoint.bind(this);
    this.handleWheel = this.handleWheel.bind(this);
    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.handleTouchMove = this.handleTouchMove.bind(this);
    this.handleTouchEnd = this.handleTouchEnd.bind(this);
    this.addProfitPopup = this.addProfitPopup.bind(this);

    // Easing functions for smooth progress
    this.easeInOutQuad = (t) => t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    this.easeInOutCubic = (t) => t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
  }

  componentDidMount() {
    this._isMounted = true;
    const canvas = this.canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    canvas.width = 1450;
    canvas.height = 920;

    this.setState({ imagesLoaded: true });

    this.engine.trigger.on("finish_crash", (data) => this.finish(data));
    this.engine.trigger.on("waiting_crash", (data) => this.waiting(data));
    this.engine.trigger.on("started_crash", (data) => this.started(data));
    this.engine.trigger.on("busted_crash", (data) => this.busted(data));
    this.engine.trigger.on("game_status", (data) => this.status(data));
    this.engine.trigger.on("visual_profit", (data) => this.addProfitPopup(data));

    // Mouse event listeners for hover tooltip
    canvas.addEventListener('mousemove', this.handleMouseMove);
    // Mouse event listeners for hover tooltip
    canvas.addEventListener('mousemove', this.handleMouseMove);
    canvas.addEventListener('mouseleave', this.handleMouseLeave);
    canvas.addEventListener('wheel', this.handleWheel, { passive: false });

    // Touch event listeners for pinch to zoom
    canvas.addEventListener('touchstart', this.handleTouchStart, { passive: false });
    canvas.addEventListener('touchmove', this.handleTouchMove, { passive: false });
    canvas.addEventListener('touchend', this.handleTouchEnd);

    // Initial draw (static)
    const initialCtx = this.canvasRef.current.getContext("2d");
    this.drawChart(initialCtx);
    // Do not start loop here; it will start on "started" event
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.isAnimating = false;
    cancelAnimationFrame(this.animationRef.gameLoop);
    this.clearAnimationData();

    // Remove mouse event listeners
    const canvas = this.canvasRef.current;
    if (canvas) {
      canvas.removeEventListener('mousemove', this.handleMouseMove);
      canvas.removeEventListener('mouseleave', this.handleMouseLeave);
      canvas.removeEventListener('wheel', this.handleWheel);
      canvas.removeEventListener('touchstart', this.handleTouchStart);
      canvas.removeEventListener('touchmove', this.handleTouchMove);
      canvas.removeEventListener('touchend', this.handleTouchEnd);
    }
  }

  // Add a new floating profit popup
  addProfitPopup(data) {
    if (!this._isMounted) return;

    const { mult, amount } = data;
    const canvas = this.canvasRef.current;
    if (!canvas) return;

    // Calculate position based on current scale
    const { scaleFactor } = this.computeYScale(this.points.slice(-Math.round(this.basePoints * this.zoomLevel)), mult);
    const y = this.getYForMult(mult, scaleFactor);

    // X position is always the current "head" of the line (75% or actual x)
    const x = canvas.width * 0.75;

    this.popups.push({
      x: x,
      y: y,
      text: `x${mult.toFixed(2)}`,
      subtext: `KES ${parseFloat(amount).toFixed(2)}`,
      alpha: 1.0,
      velocity: 1.5 // Speed of floating up
    });
  }

  // Helper to compute dynamic Y scale and labels (trading-style with small margins)
  computeYScale(visiblePoints, currentMult = null) {
    const allMults = visiblePoints.map(p => p.mult).concat(currentMult ? [currentMult] : []);

    // Calculate dynamic range based on actual data
    let dataMin = Math.min(...allMults);
    let dataMax = Math.max(...allMults);

    // Ensure we have at least some data, fallback to 1.30 if empty (avoids Y-axis starting at 1.00 on page load)
    if (!isFinite(dataMin) || !isFinite(dataMax) || dataMax <= 1.00) {
      dataMin = 1.30;
      dataMax = 1.30;
    }

    // Add small padding (0.5% on each side) for better visualization
    const range = dataMax - dataMin;
    const padding = Math.max(range * 0.005, 0.001); // At least 0.001 padding

    // Enforce minimum range to ensure small differences are visible
    // For example, 1.3890 vs 1.3895 (0.0005 diff) needs more vertical space
    const minRange = 0.01; // Minimum 0.01 range for visibility
    let minY = dataMin - padding;
    let maxY = dataMax + padding;

    // If the range is too small, expand it symmetrically
    const currentRange = maxY - minY;
    if (currentRange < minRange) {
      const expansion = (minRange - currentRange) / 2;
      minY -= expansion;
      maxY += expansion;
    }

    // Store for use in rendering
    this.yScaleMin = minY;
    this.yScaleMax = maxY;

    // Calculate scale factor
    const scaleFactor = (this.baseY - this.maxChartY) / (maxY - minY);

    // Generate dynamic labels with appropriate precision
    const labels = [];
    const labelCount = 11; // Number of labels to display
    const labelStep = (maxY - minY) / (labelCount - 1);

    // Determine precision based on step size (for trading-like display)
    let precision = 2; // Default to 4 decimal places for 0.0001 precision
    if (labelStep >= 0.01) precision = 2;
    else if (labelStep >= 0.001) precision = 3;
    else if (labelStep >= 0.0001) precision = 4;
    else precision = 5;

    // Store precision for use in rendering labels
    this.yLabelPrecision = precision;

    for (let i = 0; i < labelCount; i++) {
      const value = minY + i * labelStep;
      labels.push(parseFloat(value.toFixed(precision)));
    }

    return { scaleFactor, labels, minY, maxY };
  }

  // Helper to get Y position for a multiplier
  getYForMult(mult, scaleFactor) {
    const minY = this.yScaleMin || 1.00; // Use dynamic minY with fallback
    const y = this.baseY - (mult - minY) * scaleFactor;
    return Math.max(this.maxChartY, Math.min(y, this.baseY));
  }

  // Handle mouse move for hover tooltip
  handleMouseMove(event) {
    const canvas = this.canvasRef.current;
    if (!canvas) return;

    const rect = canvas.getBoundingClientRect();
    const scaleX = canvas.width / rect.width;
    const scaleY = canvas.height / rect.height;
    const mouseX = (event.clientX - rect.left) * scaleX;
    const mouseY = (event.clientY - rect.top) * scaleY;

    const nearestPoint = this.findNearestPoint(mouseX, mouseY);
    if (nearestPoint !== this.state.hoveredPoint) {
      this.setState({ mousePos: { x: mouseX, y: mouseY }, hoveredPoint: nearestPoint }, () => {
        const ctx = canvas.getContext('2d');
        if (ctx) this.drawChart(ctx);
      });
    }
  }

  // Handle mouse leave to clear tooltip
  handleMouseLeave() {
    if (this.state.hoveredPoint || this.state.mousePos) {
      this.setState({ mousePos: null, hoveredPoint: null }, () => {
        const canvas = this.canvasRef.current;
        if (canvas) {
          const ctx = canvas.getContext('2d');
          if (ctx) this.drawChart(ctx);
        }
      });
    }
  }

  // Handle mouse wheel for zoom
  handleWheel(event) {
    event.preventDefault();

    const zoomDelta = event.deltaY > 0 ? 0.1 : -0.1;
    const newZoom = Math.max(this.minZoom, Math.min(this.maxZoom, this.zoomLevel + zoomDelta));

    if (newZoom !== this.zoomLevel) {
      this.zoomLevel = newZoom;

      // Force redraw
      const canvas = this.canvasRef.current;
      if (canvas) {
        const ctx = canvas.getContext('2d');
        if (ctx) this.drawChart(ctx);
      }
    }
  }

  // Handle touch start for pinch zoom
  handleTouchStart(event) {
    if (event.touches.length === 2) {
      event.preventDefault(); // Prevent page scroll
      const distance = Math.hypot(
        event.touches[0].clientX - event.touches[1].clientX,
        event.touches[0].clientY - event.touches[1].clientY
      );
      this.lastTouchDistance = distance;
    }
  }

  // Handle touch move for pinch zoom
  handleTouchMove(event) {
    if (event.touches.length === 2 && this.lastTouchDistance !== null) {
      event.preventDefault(); // Prevent page scroll

      const newDistance = Math.hypot(
        event.touches[0].clientX - event.touches[1].clientX,
        event.touches[0].clientY - event.touches[1].clientY
      );

      if (newDistance > 0) {
        // Calculate zoom ratio
        const delta = newDistance - this.lastTouchDistance;
        // Sensitivity factor - adjust 0.005 as needed for feel
        const zoomDelta = delta * 0.005;

        // Invert delta: spreading fingers (positive delta) should zoom IN (lower points, lower zoomLevel in previous logic?)
        // Wait, let's check zoomLevel logic:
        // zoomLevel 1.0 = 30 points
        // zoomLevel 0.33 = 10 points (Zoomed IN to see detail)
        // zoomLevel 2.0 = 60 points (Zoomed OUT to see history)

        // Pinch OUT (spreading fingers) -> usually Zooms IN (shows fewer points, more detail)
        // So positive delta should DECREASE zoomLevel

        const newZoom = Math.max(this.minZoom, Math.min(this.maxZoom, this.zoomLevel - zoomDelta));

        if (newZoom !== this.zoomLevel) {
          this.zoomLevel = newZoom;
          this.lastTouchDistance = newDistance; // Update for continuous zoom


          // Force redraw
          const canvas = this.canvasRef.current;
          if (canvas) {
            const ctx = canvas.getContext('2d');
            if (ctx) this.drawChart(ctx);
          }
        }
      }
    }
  }

  // Handle touch end
  handleTouchEnd(event) {
    if (event.touches.length < 2) {
      this.lastTouchDistance = null;
    }
  }

  // Find nearest point to mouse cursor
  findNearestPoint(mouseX, mouseY) {
    const threshold = 30; // pixels
    const visiblePointCount = Math.round(this.basePoints * this.zoomLevel);
    const visiblePoints = this.points.slice(-visiblePointCount);
    const canvas = this.canvasRef.current;
    if (!canvas || visiblePoints.length === 0) return null;

    const { width: w } = canvas;
    const numVisible = visiblePoints.length;
    const step = numVisible > 0 ? (w - 2 * this.chartMargin) / numVisible : 50;

    // Rescale points to current positions
    const drawPointsBase = visiblePoints.map((p, i) => ({
      ...p,
      x: this.chartMargin + i * step
    }));

    // Compute Y positions
    const { scaleFactor: yScaleFactor } = this.computeYScale(drawPointsBase, null);
    const drawPoints = drawPointsBase.map(p => ({
      ...p,
      y: this.getYForMult(p.mult, yScaleFactor)
    }));

    let nearestPoint = null;
    let minDistance = threshold;

    drawPoints.forEach(point => {
      const distance = Math.sqrt(
        Math.pow(point.x - mouseX, 2) + Math.pow(point.y - mouseY, 2)
      );
      if (distance < minDistance) {
        minDistance = distance;
        nearestPoint = point;
      }
    });

    return nearestPoint;
  }

  drawChart(ctx) {
    const { width: w, height: h } = ctx.canvas;
    ctx.clearRect(0, 0, w, h);

    // Transparent background - no fill needed

    const bottomPadding = 22;
    this.baseY = h - bottomPadding;
    this.maxChartY = 0;

    // Calculate visible points based on zoom level
    const visiblePointCount = Math.round(this.basePoints * this.zoomLevel);
    const visiblePoints = this.points.slice(-visiblePointCount);
    const numVisible = visiblePoints.length;

    // Graph spans 75% of width: step = (w * 0.75) / numVisible
    const step = numVisible > 0 ? (w * 0.75) / numVisible : 50;
    const drawPointsBase = visiblePoints.map((p, i) => ({
      ...p,
      x: i * step  // Rescale x to fit within 75% of width
    }));

    let displayRate = this.state.current_amount;
    let livePoint = null;
    let currentMult = null;

    // Live rising line during started (continuation from last point, no reset)
    if (this.state.status === "started" && this.startTime) {
      const lastPoint = drawPointsBase.length > 0 ? drawPointsBase[drawPointsBase.length - 1] : { x: 0, y: this.baseY, mult: 1.00 };
      const lastBustX = lastPoint.x;
      const lastMult = lastPoint.mult;
      const elapsed = Date.now() - this.startTime;
      const linearProgress = Math.min(elapsed / this.expectedRoundTime, 1);
      const easedProgress = this.easeInOutCubic(linearProgress); // Apply easing for smoothness
      const currentX = lastBustX + easedProgress * step;
      // Continue rising from last mult, not reset to 1
      const growth = Math.exp(0.0007 * elapsed); // Exponential growth factor
      const live_mult = lastMult * growth;
      displayRate = live_mult.toFixed(2);

      // Slowness/Smoothing effect: lerp current state towards target
      const targetLerp = live_mult;
      const currentLerp = this.state.lerp_amount || 1.00;
      const lerpFactor = 0.15; // Lower = slower/heavier feel
      const nextLerp = currentLerp + (targetLerp - currentLerp) * lerpFactor;

      // Update state if significantly different to drive animation smoothly
      if (Math.abs(nextLerp - currentLerp) > 0.001) {
        this.setState({ lerp_amount: nextLerp });
      }

      // Use lerp_amount for visuals if started
      const visual_mult = nextLerp;
      const { scaleFactor: liveScaleFactor } = this.computeYScale(drawPointsBase, visual_mult);
      const live_y = this.getYForMult(visual_mult, liveScaleFactor);
      livePoint = { x: currentX, y: live_y, mult: visual_mult, timestamp: Date.now() };
      drawPointsBase.push(livePoint);
      currentMult = visual_mult;
    }

    // Compute dynamic Y scale based on points and live
    const { scaleFactor: yScaleFactor, labels: yLabels } = this.computeYScale(drawPointsBase, currentMult);
    this.yScaleFactor = yScaleFactor; // Store for use in busted()

    // Adjust draw points Y to new scale
    const drawPoints = drawPointsBase.map(p => ({
      ...p,
      y: this.getYForMult(p.mult, yScaleFactor)
    }));

    // Grid (Y based on dynamic scale) - subtle refined lines
    ctx.strokeStyle = "#2a2e3a";
    ctx.lineWidth = 0.5;
    const gridStepY = 100;
    const gridStepX = 200; // Spacing for vertical grid lines

    // Horizontal grid lines - moved to yLabels loop to ensure consistency with Y axis
    ctx.strokeStyle = "#2a2e3a";
    ctx.lineWidth = 0.5;

    // Vertical grid lines - handled in time label loop below to ensure alignment

    // Y-axis labels (dynamic) - at the far right end
    ctx.fillStyle = "#8a9ba8";
    ctx.font = "bold 12px Arial";
    ctx.textAlign = "right";
    yLabels.forEach((val) => {
      let ly = this.getYForMult(val, yScaleFactor);

      // Draw horizontal grid line across full width
      ctx.strokeStyle = "#2a2e3a";
      ctx.lineWidth = 0.5;
      ctx.beginPath();
      ctx.moveTo(0, ly);
      ctx.lineTo(w, ly);
      ctx.stroke();

      // Draw text for all calculated label points
      ctx.fillStyle = "#8a9ba8";
      const text = val.toFixed(this.yLabelPrecision || 5);
      ctx.fillText(text, w - 8, ly + 4);
    });

    // Permanent history + live: Connected smooth curve (Bezier Spline)
    if (drawPoints.length > 0) {
      // Save canvas state for clipping
      ctx.save();

      // If game is running and we have a live point, animate the line progressively
      if (this.state.status === "started" && drawPoints.length > 0) {
        const lastPoint = drawPoints[drawPoints.length - 1];

        // Update target X position when new data arrives
        if (lastPoint.x !== this.lastLiveX) {
          this.lastLiveX = lastPoint.x;
        }

        // Smoothly animate toward target X
        if (this.animatedX < this.lastLiveX) {
          this.animatedX += (this.lastLiveX - this.animatedX) * this.animationSpeed;
        }

        // Clip drawing to only show up to animated X position
        ctx.beginPath();
        ctx.rect(0, 0, this.animatedX, h);
        ctx.clip();
      }

      // Build the curve path
      ctx.beginPath();
      ctx.moveTo(drawPoints[0].x, drawPoints[0].y);

      if (drawPoints.length > 1) {
        // Use smooth Catmull-Rom spline for natural trading chart curves
        for (let i = 0; i < drawPoints.length - 1; i++) {
          const p0 = i > 0 ? drawPoints[i - 1] : drawPoints[i];
          const p1 = drawPoints[i];
          const p2 = drawPoints[i + 1];
          const p3 = i < drawPoints.length - 2 ? drawPoints[i + 2] : p2;

          // Catmull-Rom to Bezier conversion
          const cp1x = p1.x + (p2.x - p0.x) / 6;
          const cp1y = p1.y + (p2.y - p0.y) / 6;
          const cp2x = p2.x - (p3.x - p1.x) / 6;
          const cp2y = p2.y - (p3.y - p1.y) / 6;

          ctx.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, p2.x, p2.y);
        }
      } else {
        ctx.lineTo(drawPoints[0].x, drawPoints[0].y);
      }

      // === Neon Glow Effect — 3-pass rendering ===
      // Pass 1: Wide outer glow
      ctx.strokeStyle = "rgba(74, 159, 245, 0.08)";
      ctx.lineWidth = 8;
      ctx.stroke();

      // Pass 2: Medium inner glow
      ctx.strokeStyle = "rgba(74, 159, 245, 0.18)";
      ctx.lineWidth = 4;
      ctx.stroke();

      // Pass 3: Sharp core line
      ctx.strokeStyle = "rgba(74, 159, 245, 0.85)";
      ctx.lineWidth = 2;
      ctx.stroke();

      // Restore canvas state (remove clipping)
      ctx.restore();

      // Fill below curve with blue gradient
      const gradient = ctx.createLinearGradient(0, this.maxChartY, 0, this.baseY);
      gradient.addColorStop(0, "rgba(74, 159, 245, 0.4)");
      gradient.addColorStop(1, "rgba(74, 159, 245, 0.05)");
      ctx.fillStyle = gradient;
      ctx.beginPath();
      ctx.moveTo(drawPoints[0].x, this.baseY);
      ctx.lineTo(drawPoints[0].x, drawPoints[0].y);

      if (drawPoints.length > 1) {
        // Use same smooth curve for fill area
        for (let i = 0; i < drawPoints.length - 1; i++) {
          const p0 = i > 0 ? drawPoints[i - 1] : drawPoints[i];
          const p1 = drawPoints[i];
          const p2 = drawPoints[i + 1];
          const p3 = i < drawPoints.length - 2 ? drawPoints[i + 2] : p2;

          const cp1x = p1.x + (p2.x - p0.x) / 6;
          const cp1y = p1.y + (p2.y - p0.y) / 6;
          const cp2x = p2.x - (p3.x - p1.x) / 6;
          const cp2y = p2.y - (p3.y - p1.y) / 6;

          ctx.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, p2.x, p2.y);
        }
      }

      ctx.lineTo(drawPoints[drawPoints.length - 1].x, this.baseY);
      ctx.closePath();
      ctx.fill();

      // Horizontal line at current live/crash point (PocketOption style)
      if (livePoint && this.state.status === "started") {
        const liveY = Math.max(0, Math.min(livePoint.y, h));
        ctx.strokeStyle = "rgba(74, 159, 245, 0.6)";
        ctx.lineWidth = 1;
        ctx.setLineDash([5, 5]);
        ctx.beginPath();
        ctx.moveTo(0, liveY);
        ctx.lineTo(w, liveY);
        ctx.stroke();
        ctx.setLineDash([]);

        // Current point indicator (glowing dot)
        const liveX = Math.max(0, Math.min(livePoint.x, w * 0.75));
        ctx.save();
        ctx.shadowBlur = 18;
        ctx.shadowColor = "#4a9ff5";
        ctx.fillStyle = "#4a9ff5";
        ctx.beginPath();
        ctx.arc(liveX, liveY, 5, 0, 2 * Math.PI);
        ctx.fill();
        ctx.strokeStyle = "rgba(74, 159, 245, 0.8)";
        ctx.lineWidth = 2;
        ctx.stroke();
        ctx.restore();

        // Rate label at the far right end
        const rateText = `${livePoint.mult.toFixed(2)}`;
        ctx.font = "bold 12px Arial";
        ctx.fillStyle = "#fff";
        ctx.textAlign = "right";
        const labelBgWidth = ctx.measureText(rateText).width + 12;
        const labelX = w - 5;
        const labelY = liveY - 8;

        // Label background
        ctx.fillStyle = "rgba(74, 159, 245, 0.9)";
        ctx.fillRect(labelX - labelBgWidth, labelY, labelBgWidth, 18);

        // Label text
        ctx.fillStyle = "#fff";
        ctx.fillText(rateText, labelX - 6, liveY + 4);
      }
    }

    // Bust marker (red dot + dashed vertical on last point if busted)
    if (this.state.status === "busted" && this.points.length > 0) {
      const lastP = drawPoints[drawPoints.length - 1]; // Use scaled point
      const bx = Math.max(0, Math.min(lastP.x, w * 0.75));
      const by = Math.max(0, Math.min(lastP.y, h));

      // Store crash point for persistent display
      this.lastCrashPoint = { x: bx, y: by, mult: lastP.mult, time: lastP.time };

      // Vertical dashed line
      ctx.strokeStyle = "rgba(74, 159, 245, 0.9)";
      ctx.lineWidth = 2;
      ctx.setLineDash([5, 5]);
      ctx.beginPath();
      ctx.moveTo(bx, by);
      ctx.lineTo(bx, this.baseY);
      ctx.stroke();
      ctx.setLineDash([]);
      ctx.fillStyle = "rgba(74, 159, 245, 0.9)";
      ctx.beginPath();
      ctx.arc(bx, by, 6, 0, 2 * Math.PI);
      ctx.fill();
    }

    // Persistent crash indicator
    if (this.lastCrashPoint && (this.state.status === "busted" || this.state.status === "idle")) {
      const { x: crashX, y: crashY, mult: crashMult } = this.lastCrashPoint;

      // Crash point marker (dot at the crash position)
      ctx.save();

      // Add pulse and glow effect ONLY when game just crashed (busted status)
      if (this.state.status === "busted") {
        ctx.shadowBlur = 20;
        ctx.shadowColor = "#4a9ff5";

        // Draw pulsing outer ring
        const pulse = (Math.sin(Date.now() / 150) + 1) / 2; // Oscillate 0 to 1
        const pulseRadius = 5 + pulse * 15;
        ctx.strokeStyle = `rgba(74, 159, 245, ${0.4 * (1 - pulse)})`;
        ctx.lineWidth = 3;
        ctx.beginPath();
        ctx.arc(crashX, crashY, pulseRadius, 0, 2 * Math.PI);
        ctx.stroke();
      }

      ctx.fillStyle = "#4a9ff5";
      ctx.beginPath();
      ctx.arc(crashX, crashY, 5, 0, 2 * Math.PI);
      ctx.fill();
      ctx.strokeStyle = "rgba(74, 159, 245, 0.8)";
      ctx.lineWidth = 2;
      ctx.stroke();

      ctx.restore();

      // Horizontal line starting from crash dot (solid, not dashed)
      ctx.strokeStyle = "rgba(74, 159, 245, 0.6)";
      ctx.lineWidth = 1;
      ctx.setLineDash([]); // Solid line
      ctx.beginPath();
      ctx.moveTo(crashX, crashY); // Start from dot position
      ctx.lineTo(w, crashY);
      ctx.stroke();

      const crashText = `${crashMult.toFixed(5)}`;
      ctx.font = "bold 12px Arial";
      ctx.fillStyle = "#fff";
      ctx.textAlign = "right";
      const crashLabelWidth = ctx.measureText(crashText).width + 12;
      const crashLabelX = w - 5;

      // Label background
      ctx.fillStyle = "rgba(74, 159, 245, 0.9)";
      ctx.fillRect(crashLabelX - crashLabelWidth, crashY - 9, crashLabelWidth, 18);

      // Label text
      ctx.fillStyle = "#fff";
      ctx.fillText(crashText, crashLabelX - 6, crashY + 4);
    }

    // X-axis labels (time) - 15 second intervals internal
    ctx.fillStyle = "#8a9ba8";
    ctx.font = "10px Arial";
    ctx.textAlign = "center";
    ctx.textBaseline = "bottom";

    // Draw labels and grid based on 15s intervals
    for (let i = 0; i < drawPoints.length - 1; i++) {
      const p1 = drawPoints[i];
      const p2 = drawPoints[i + 1];

      if (p1.timestamp && p2.timestamp) {
        const interval = 15000; // 15 seconds in ms
        let firstTick = Math.ceil(p1.timestamp / interval) * interval;

        for (let t = firstTick; t <= p2.timestamp; t += interval) {
          const ratio = (t - p1.timestamp) / (p2.timestamp - p1.timestamp);
          const tx = p1.x + (p2.x - p1.x) * ratio;

          if (tx >= 0 && tx <= w * 0.75) {
            // Draw vertical grid line (up to baseY)
            ctx.strokeStyle = "#2a2e3a";
            ctx.lineWidth = 0.5;
            ctx.beginPath();
            ctx.moveTo(tx, 0);
            ctx.lineTo(tx, this.baseY);
            ctx.stroke();

            // Draw time label in bottom zone
            const date = new Date(t);
            const label = date.getHours().toString().padStart(2, '0') + ":" +
              date.getMinutes().toString().padStart(2, '0') + ":" +
              date.getSeconds().toString().padStart(2, '0');
            ctx.fillStyle = "#8a9ba8";
            ctx.fillText(label, tx, h - 5);
          }
        }
      }
    }

    // Future time projection (right 25% area)
    if (drawPoints.length >= 2) {
      const p1 = drawPoints[drawPoints.length - 2];
      const lastP = drawPoints[drawPoints.length - 1];
      if (p1.timestamp && lastP.timestamp && lastP.x > p1.x) {
        const msPerPixel = (lastP.timestamp - p1.timestamp) / (lastP.x - p1.x);
        const interval = 15000;
        let nextTick = Math.ceil((lastP.timestamp + 1) / interval) * interval;

        for (let t = nextTick; ; t += interval) {
          const tx = lastP.x + (t - lastP.timestamp) / msPerPixel;
          if (tx > w) break;

          if (tx > lastP.x) {
            // Draw vertical grid line
            ctx.strokeStyle = "#2a2e3a";
            ctx.lineWidth = 0.5;
            ctx.beginPath();
            ctx.moveTo(tx, 0);
            ctx.lineTo(tx, this.baseY);
            ctx.stroke();

            // Draw time label
            const date = new Date(t);
            const label = date.getHours().toString().padStart(2, '0') + ":" +
              date.getMinutes().toString().padStart(2, '0') + ":" +
              date.getSeconds().toString().padStart(2, '0');
            ctx.fillStyle = "#8a9ba8";
            ctx.fillText(label, tx, h - 5);
          }
        }

        // Calculate stable msPerPixel ratio from the entire visible range for better accuracy
        let stableMsPerPixel = msPerPixel;
        if (drawPoints.length >= 3) {
          const firstPoint = drawPoints[0];
          const lastPoint = drawPoints[drawPoints.length - 1];
          if (firstPoint.timestamp && lastPoint.timestamp && lastPoint.x > firstPoint.x) {
            stableMsPerPixel = (lastPoint.timestamp - firstPoint.timestamp) / (lastPoint.x - firstPoint.x);
          }
        }

        // Draw Active Trade Annotations
        if (this.engine.activeTrades && this.engine.activeTrades.length > 0) {
          // Get the very last point in the visible trace (the pulsing head)
          const lastPointInTrace = drawPoints[drawPoints.length - 1];

          this.engine.activeTrades.forEach(trade => {
            if (!lastPointInTrace) return;

            // Robust Check: Hide if visually in the future
            // 1. Time Check: Hide if entry time hasn't been reached by the trace head
            // (Using a 100ms buffer to handle small sync jitters)
            if (trade.entryTime > (lastPointInTrace.timestamp + 100)) {
              return;
            }

            // 2. Multiplier Check: Specifically during active round to prevent premature rise
            if (this.state.status === 'started') {
              if (currentMult === null || currentMult < trade.entryMult) {
                return;
              }
            }

            // Calculate entry Y position using the SAME scaleFactor as the Y-axis labels
            // This ensures precise alignment with the grid
            const entryY = this.getYForMult(trade.entryMult, yScaleFactor);

            // Find exact entry point position by interpolating between points
            let entryX = 0;
            let foundExactPosition = false;

            // Search through visible points to find the two points surrounding entry time
            for (let i = 0; i < drawPoints.length - 1; i++) {
              const point1 = drawPoints[i];
              const point2 = drawPoints[i + 1];

              if (point1.timestamp && point2.timestamp) {
                // Check if entry time falls between these two points
                if (trade.entryTime >= point1.timestamp && trade.entryTime <= point2.timestamp) {
                  // Interpolate exact X position between the two points
                  const timeDiff = point2.timestamp - point1.timestamp;
                  const timeOffset = trade.entryTime - point1.timestamp;
                  const ratio = timeDiff > 0 ? timeOffset / timeDiff : 0;
                  entryX = point1.x + (point2.x - point1.x) * ratio;
                  foundExactPosition = true;
                  break;
                }
                // Check if entry time exactly matches point1
                else if (Math.abs(trade.entryTime - point1.timestamp) < 50) {
                  entryX = point1.x;
                  foundExactPosition = true;
                  break;
                }
              }
            }

            // Check the last point as well
            if (!foundExactPosition && drawPoints.length > 0) {
              const lastPoint = drawPoints[drawPoints.length - 1];
              if (lastPoint.timestamp && Math.abs(trade.entryTime - lastPoint.timestamp) < 50) {
                entryX = lastPoint.x;
                foundExactPosition = true;
              }
            }

            // Fallback: if no matching point found in visible range, 
            // calculate position relative to last point
            if (!foundExactPosition) {
              const timeFromEntryToLast = lastP.timestamp - trade.entryTime;
              entryX = lastP.x - (timeFromEntryToLast / stableMsPerPixel);
            }

            // Calculate expiry position using interpolation (same method as entry point for consistency)
            let tradeExpX = 0;
            let foundExpiry = false;

            // Search for expiry time within visible points or project it forward
            for (let i = 0; i < drawPoints.length - 1; i++) {
              const point1 = drawPoints[i];
              const point2 = drawPoints[i + 1];

              if (point1.timestamp && point2.timestamp) {
                // Check if expiry time falls between these two points
                if (trade.expiryTime >= point1.timestamp && trade.expiryTime <= point2.timestamp) {
                  // Interpolate exact X position between the two points
                  const timeDiff = point2.timestamp - point1.timestamp;
                  const timeOffset = trade.expiryTime - point1.timestamp;
                  const ratio = timeDiff > 0 ? timeOffset / timeDiff : 0;
                  tradeExpX = point1.x + (point2.x - point1.x) * ratio;
                  foundExpiry = true;
                  break;
                }
              }
            }

            // If expiry not in visible range, project it forward from last point using stable ratio
            if (!foundExpiry) {
              const timeToExpiry = trade.expiryTime - lastP.timestamp;
              tradeExpX = lastP.x + (timeToExpiry / stableMsPerPixel);
            }

            // Determine colors based on trade type (slot  1 = BUY = Green, slot 2 = SELL = Red)
            const isBuy = trade.slot === 1;
            const markerColor = isBuy ? "rgba(16, 185, 129, 0.7)" : "rgba(242 ,103, 34,0.7)"; // Green for BUY, Red for SELL
            const lineColor = isBuy ? "rgba(16, 185, 129, 0.7)" : "rgba(242 ,103, 34,0.7)"; //   Green for BUY, Red for SELL

            // Draw horizontal entry line across chart at exact entry Y position
            ctx.save(); // Save current context state
            ctx.strokeStyle = lineColor;
            ctx.lineWidth = 2;
            ctx.setLineDash([]); // Solid line
            ctx.beginPath();
            ctx.moveTo(entryX, entryY); // Start exactly at entry point
            // End at the vertical expiration line if visible, otherwise extend to width
            const endX = (tradeExpX > 0 && tradeExpX <= w) ? tradeExpX : w;
            ctx.lineTo(endX, entryY);
            ctx.stroke();
            ctx.restore(); // Restore context state

            // Entry Point Marker (dot at entry position) - draw AFTER the line
            ctx.fillStyle = markerColor;
            ctx.beginPath();
            ctx.arc(entryX, entryY, 4, 0, 2 * Math.PI);
            ctx.fill();
            ctx.strokeStyle = "rgba(255, 255, 255, 0.8)";
            ctx.lineWidth = 1;
            ctx.stroke();

            // Draw entry multiplier label on Y-axis (right side) to show exact entry value
            ctx.save();
            const entryMultText = trade.entryMult.toFixed(2);
            ctx.font = "bold 12px Arial";
            ctx.textAlign = "right";
            const entryLabelBgWidth = ctx.measureText(entryMultText).width + 12;
            const entryLabelX = w - 5;
            const entryLabelHeight = 18;
            const entryLabelRectY = entryY - entryLabelHeight / 2;

            // Label background (same color as trade type)
            ctx.fillStyle = markerColor;
            ctx.fillRect(entryLabelX - entryLabelBgWidth, entryLabelRectY, entryLabelBgWidth, entryLabelHeight);

            // Label text
            ctx.fillStyle = "#fff";
            ctx.textBaseline = "middle";
            ctx.fillText(entryMultText, entryLabelX - 6, entryY);
            ctx.restore();

            // Stake Label (placed at entry point)
            ctx.fillStyle = "#fff";
            ctx.font = "bolder 12px Arial";
            ctx.textAlign = "left"; // Changed to left alignment for better visibility
            const labelX = entryX + 8; // Offset from entry point
            const labelY = entryY - 8;

            // Draw label background for better readability
            const labelText = `${trade.amount} KES`;
            ctx.save();
            ctx.font = "bolder 12px Arial";
            const labelWidth = ctx.measureText(labelText).width + 12;
            const labelHeight = 18;
            const labelRectX = labelX - 6;
            const labelRectY = entryY - labelHeight - 4;
            ctx.fillStyle = markerColor;
            ctx.fillRect(labelRectX, labelRectY, labelWidth, labelHeight);
            ctx.fillStyle = "#fff";
            ctx.textBaseline = "middle";
            ctx.fillText(labelText, labelX, labelRectY + labelHeight / 2);
            ctx.restore();

            // Vertical Expiration Line for this trade
            if (tradeExpX > 0 && tradeExpX <= w) {
              ctx.strokeStyle = markerColor; // Green for BUY, Red for SELL
              ctx.lineWidth = 2;
              ctx.setLineDash([]); // Solid line
              ctx.beginPath();
              ctx.moveTo(tradeExpX, 0); // Extend all the way to top
              ctx.lineTo(tradeExpX, this.baseY);
              ctx.stroke();

              // Expiry Label
              ctx.fillStyle = markerColor;
              ctx.font = "bold 9px Arial";
              ctx.textAlign = "center";
              ctx.fillText("EXPIRY", tradeExpX, 25);
            }
            ctx.setLineDash([]);
          });
        }
      }
    }

    // Draw Floating Profit Popups
    if (this.popups && this.popups.length > 0) {
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";

      for (let i = this.popups.length - 1; i >= 0; i--) {
        const p = this.popups[i];
        ctx.save();
        ctx.globalAlpha = p.alpha;

        // Draw shadow/glow
        ctx.shadowBlur = 15;
        ctx.shadowColor = "rgba(16, 185, 129, 0.9)";

        // Draw Multiplier
        // ctx.font = "bold 28px Arial";
        // ctx.fillStyle = "#10b981";
        // ctx.fillText(p.text, p.x, p.y);

        // Draw KES amount below
        ctx.font = "bold 16px Arial";
        ctx.fillStyle = "#10b981";
        ctx.fillText(p.subtext, p.x, p.y + 30);

        ctx.restore();

        // Update state for next frame
        p.y -= p.velocity;
        p.alpha -= 0.012; // Slower fade for better visibility

        // Remove if invisible
        if (p.alpha <= 0) {
          this.popups.splice(i, 1);
        }
      }
    }

  }

  gameLoop() {
    if (!this._isMounted || !this.isAnimating) return;

    const ctx = this.canvasRef.current?.getContext("2d");
    if (ctx) {
      this.drawChart(ctx);
    }

    this.animationRef.gameLoop = requestAnimationFrame(this.gameLoop);
  }

  clearAnimationData() {
    const canvas = this.canvasRef.current;
    if (canvas) {
      const ctx = canvas.getContext("2d");
      this.drawChart(ctx);
    }

    this.isAnimating = false;
    cancelAnimationFrame(this.animationRef.gameLoop);
    this.startTime = null;
  }

  startCrashAnimation() {
    const canvas = this.canvasRef.current;
    if (!canvas) return;

    this.gameISStarted.current = true;
    const lastBustX = this.points.length > 0 ? this.points[this.points.length - 1].x : this.chartMargin;
    this.startRoundX = lastBustX;
    this.startTime = Date.now() - this.serverElapsed;
    this.isStopGame.current = true;
    this.isAnimating = true; // Start animation
    this.lastCrashPoint = null; // Clear crash indicator when new round starts

    // Initialize progressive drawing animation
    this.animatedX = lastBustX; // Start from last crash point
    this.lastLiveX = lastBustX;

    this.setState({ status: "started" });
    this.gameLoop(); // Draw initial frame and start loop
  }

  finish(data) {
    if (this._isMounted) {
      // console.log('Canvas finish_crash:', data);
    }
  }

  waiting(data) {
    if (this._isMounted) {
      this.setState({
        status: "idle",
        inPlay: false,
        current_amount: this.state.rate || "1.00",
      }, () => {
        Game["current_amount"] = this.state.rate || "1.00";
        this.gameISStarted.current = false;
        this.isAnimating = false;
        cancelAnimationFrame(this.animationRef.gameLoop);
        const ctx = this.canvasRef.current?.getContext("2d");
        if (ctx) this.drawChart(ctx); // Draw final static state
      });
    }
  }

  started(data) {
    if (this._isMounted) {
      let { time, md5 } = data;
      const lastPoint = this.points.length > 0 ? this.points[this.points.length - 1] : { mult: 1.00 };
      const lastMult = lastPoint.mult;
      const growth = Math.exp(0.0007 * time);
      let initialAmount = (lastMult * growth).toFixed(2);
      this.serverElapsed = time;
      if (this.state.status !== "started" && !this.gameISStarted.current) {
        this.gameISStarted.current = true;
        this.setState(
          {
            status: "started",
            inPlay: true,
            timer: time,
            current_amount: initialAmount,
            startedTime: Date.now() - time,
            timePassed: time,
            rate: "",
          },
          () => {
            // console.log('started: Start live animation at initial mult:', initialAmount);
            Game["current_amount"] = initialAmount;
            // this.startCrashAnimation();
          }
        );
      }
    }
  }


  busted(data) {
    if (this._isMounted) {
      // console.log('busted_crash Data:', data);

      let { amount, time } = data;
      let rate = amount / 100; // Store raw value without rounding
      if (rate <= 0) rate = 1.0000; // Safeguard against invalid amount

      const numHistory = this.points.length;
      const step = numHistory > 0 ? (this.points[this.points.length - 1].x - this.chartMargin) / numHistory : 50; // Approximate step
      const bust_x = this.startRoundX + step;
      // Use stored yScaleFactor (computed in drawChart, but for consistency, we'll recompute here if needed)
      // Note: y is now computed dynamically in drawChart, so we store only x and mult; y is derived
      const now = new Date();
      const timeStr = now.getHours().toString().padStart(2, '0') + ":" +
        now.getMinutes().toString().padStart(2, '0') + ":" +
        now.getSeconds().toString().padStart(2, '0');
      this.points.push({ x: bust_x, mult: rate, time: timeStr, timestamp: now.getTime() }); // Store raw value
      this.lastMult = rate; // Update last mult for next continuation

      // Keep only last maxPoints
      if (this.points.length > this.maxPoints) {
        this.points.shift();
      }

      this.averageBust = this.averageBust * 0.8 + rate * 0.2;

      this.setState({
        status: "busted",
        inPlay: false,
        rate: rate, // Store raw value
        timer: time,
        current_amount: rate, // Store raw value
        startedTime: Date.now() - time,
        timePassed: time,
      }, () => {
        Game["current_amount"] = rate.toFixed(5); // Format only for display
        this.isStopGame.current = false;
        const ctx = this.canvasRef.current?.getContext("2d");
        if (ctx) this.drawChart(ctx); // Draw bust state
        setTimeout(() => {
          this.setState({ status: "idle" }, () => {
            this.isAnimating = false;
            cancelAnimationFrame(this.animationRef.gameLoop);
            const finalCtx = this.canvasRef.current?.getContext("2d");
            if (finalCtx) this.drawChart(finalCtx); // Redraw idle state
          });
          this.serverElapsed = 0;
        }, 1500);
      });
    }
  }

  status(data) {
    if (this._isMounted) {
      // console.log('Canvas game_status:', data);
      let { amount, time, md5, status: newStatus, crashes } = data;

      // Restore points from history if empty
      if (crashes && crashes.length > 0) {
        this.points = crashes
          .map(c => {
            let rawValue = c.crash !== undefined ? c.crash : c.amount;
            let mult = rawValue / 100; // Store raw value without rounding
            let timeStr = "";
            let timestamp = null;
            if (c.time) {
              const d = new Date(c.time.replace(' ', 'T'));
              if (!isNaN(d.getTime())) {
                timestamp = d.getTime();
                timeStr = d.getHours().toString().padStart(2, '0') + ":" +
                  d.getMinutes().toString().padStart(2, '0') + ":" +
                  d.getSeconds().toString().padStart(2, '0');
              }
            }
            return {
              mult: mult, // Store raw value
              time: timeStr,
              timestamp: timestamp
              // x and y will be calculated during drawChart
            };
          })
          .filter(p => p.mult >= 1.0) // Filter out any points < 1.0 (invalid data)
          .slice(-this.maxPoints);

        // Force redraw with new data to update y-axis labels
        const ctx = this.canvasRef.current?.getContext("2d");
        if (ctx) this.drawChart(ctx);
      }

      let rate = newStatus === "busted" ? (amount / 100).toFixed(2) : this.state.rate;
      let currentAmount;
      if (newStatus === "started") {
        const lastPoint = this.points.length > 0 ? this.points[this.points.length - 1] : { mult: 1.00 };
        const lastMult = Math.max(1.00, lastPoint.mult); // Ensure at least 1.00
        const growth = Math.exp(0.0007 * time);
        currentAmount = (lastMult * growth).toFixed(2);
        this.serverElapsed = time;
      } else {
        currentAmount = newStatus === "busted" ? rate : this.state.current_amount;
      }

      this.setState(
        {
          status: newStatus,
          timer: time,
          connecting: false,
          rate: rate,
          current_amount: currentAmount,
          startedTime:
            newStatus === "started" ? Date.now() - time :
              newStatus === "busted" ? Date.now() - time : this.state.startedTime,
          timePassed: newStatus === "started" || newStatus === "busted" ? time : this.state.timePassed,
        },
        () => {
          const ctx = this.canvasRef.current?.getContext("2d");
          if (newStatus === "busted") {
            Game["current_amount"] = rate;
            this.busted(data);
          } else if (newStatus === "started" && !this.gameISStarted.current) {
            // if (time > 2000) return;
            Game["current_amount"] = currentAmount;
            this.startCrashAnimation();
          } else {
            // For idle/waiting/finish: draw once and stop animation
            if (ctx) this.drawChart(ctx);
            this.isAnimating = false;
            cancelAnimationFrame(this.animationRef.gameLoop);
          }
        }
      );
    }
  }

  render() {
    const { t } = this.props;
    const { loadingError } = this.state;

    return (
      <Card className="no-shadow mb-0 game-wrapper-card game-chart-black-animation">
        <Card.Body className="bg-body text-center no-shadow pt-3 static-snow p-0" id="canvasPart">
          <div className="game-holder">
            <Card className="mb-0 bg-transparent">
              <Card.Body className="pt-0" style={{ padding: 0 }}>
                {/* <div className="history_">
                  <HistoryList game="crash" t={t} />
                </div> */}
                <div className="asset-label-card">
                  <span className="asset-name">USD / CAD</span>
                  {/* <span className="asset-percentage">89%</span> */}
                </div>
                <canvas ref={this.canvasRef} style={{ maxWidth: "100%", height: "auto" }} />
                {loadingError && (
                  <div style={{ color: "red", marginTop: "10px" }}>{loadingError}</div>
                )}
              </Card.Body>
            </Card>
          </div>
        </Card.Body>
      </Card>
    );
  }
}

Canvas.propTypes = {
  profit: PropTypes.string,
  im_in_game: PropTypes.bool,
  t: PropTypes.func,
};

const mapStateToProps = (state) => ({
  profit: state.items.profit,
  im_in_game: state.items.im_in_game,
});

export default connect(mapStateToProps, {})(Canvas);